import React from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from '../../icons/arrowIcon';
import { Link } from 'inside-out/components/shared/link';
import {
	wrapperStyle,
	wrapperLinkStyle,
	ctaStyle,
	imgStyle,
	titleStyle,
	bodyStyle,
} from './styles';

export const EmploymentCard = ({ to, title, body, img, linkText }) => (
	<Link className={wrapperLinkStyle} to={to} data-component="Card">
		<article className={wrapperStyle}>
			<img src={img} alt="" className={imgStyle} />
			<h1 className={titleStyle}>{title}</h1>
			<p className={bodyStyle}>{body}</p>
			<p className={ctaStyle}>
				{linkText} <ArrowIcon />
			</p>
		</article>
	</Link>
);

EmploymentCard.propTypes = {
	to: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	body: PropTypes.string.isRequired,
	linkText: PropTypes.string,
	img: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/shared/cards/employmentCard/component.js